// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactDragListView from 'react-drag-listview/lib/index.js';
import moment from "moment";

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
    Label,
} from "reactstrap"
import { IoIosAdd } from "react-icons/io";
import { GrDrag } from "react-icons/gr";
import Select from "react-select";


//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import { listGroupNorms, listGroupNormsDetails } from "store/actions";
import AddEditModal from "../AddEdit/GenerateNorms";
import toastr from "toastr";
import { withTranslation } from "react-i18next";
import { MdArrowBackIos } from "react-icons/md";


const List = props => {
    //meta title
    document.title = `${props.t("Norms")}  | ${props.t("Admin")}`;

    const { error, success, loading } = useSelector(state => ({
        loading: state.Norms.loading,
        error: state.Norms.error,
        success: state.Norms.success,
    }));
    const { state } = useLocation();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [batchQuestionnaireData, setBatchQuestionnaireData] = useState()
    const [modal, setModal] = useState(false);
    const [itemData, SetItemData] = useState();
    const [tableData, SetTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [options, setoptions] = useState([]);

    const [filterData, setFilterData] = useState({
        "limit": 25,
        "page": currentPage,
        "search": ""
    });
    const [selectValue, setSelectValue] = useState()


    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };

    // list
    const fetchGroupNormsDetailsList = (data) => {
        dispatch(listGroupNormsDetails(data, (res) => {
            if (res?.status === 'success') {
                SetTableData(res)
                SetItemData({})
            }
        }))
    }
    useEffect(() => {
        fetchGroupNormsDetailsList(state?.batchData?.id)
    }, [])


    return (
        <React.Fragment>
            <AddEditModal
                modal={modal}
                toggle={toggle}
                itemData={itemData}
                fetchGroupNormsListData={() => fetchGroupNormsList(filterData)}
            />
            <div className="page-content">
                <div className="container-fluid">
                <div className="text-icon-back">
                    <MdArrowBackIos style={{ cursor: "pointer" }} onClick={() => navigate(-1)} /> <Breadcrumbs isBack='yes' title={props.t("Norms")} breadcrumbItem={props.t("Group Norm")} breadcrumbItemText={props.t("Group Questionnaire Norm")} />
                </div>

                    <Row>
                        <Col lg="12">
                            <Row className="mb-2 d-flex show-select show-select justify-spacebetween">
                                <Col md={12}>
                                    <div className="mb-3 d-flex gap-4">
                                        {
                                            state?.batchData ?
                                                <>
                                                    <h5><b>Norm Name:</b>{state?.batchData?.norm_name}</h5>
                                                    <h5><b>Generate On: </b>{moment(state?.batchData?.created_at).format("DD/MM/YYYY")}</h5>
                                                    <h5><b>Participant Count: </b>{state?.batchData?.participants_count}</h5>
                                                </>
                                                :
                                                ""
                                        }

                                    </div>
                                </Col>
                            </Row>
                            <div className="main-norms-list">
                                {
                                    loading ?
                                        <div className="loader d-flex justify-content-center align-items-center" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        <Row>
                                            {/* <div className="" style={{textAlign:"center"}}><b className="inner-norms-list-gen">Generated On:</b> {moment(tableData?.data[0]?.item?.created_at).format("MMM Do YY")}</div> */}
                                            {/* {
                                             tableData?.data || tableData?.data?.length <= 0 
                                                &&
                                                <div className="" style={{textAlign:"center"}}>No Record Found</div>

                                        } */}
                                            {

                                                (tableData?.data || []).map((item, index) => {
                                                    return (
                                                        <Col md={6} key={index} className="inner-norms-list-col">
                                                            <div className="inner-norms-list">
                                                            <div className="d-flex"><span style={{marginRight:'5px',fontWeight:"bold", fontSize:"15px"}}>Q. {index + 1}</span> <span dangerouslySetInnerHTML={{ __html: item?.aspiration_text }}></span></div>
                                                                
                                                                <Table className="table mb-0 table-space" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Raters</th>
                                                                            <th> {props.t("SCHO")}</th>
                                                                            <th> {props.t("R")}</th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        <tr>
                                                                            <td><b>Boss</b></td>
                                                                            <td>{parseFloat(item?.scho_boss).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_boss).toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><b>Superior</b></td>
                                                                            <td>{parseFloat(item?.scho_superior).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_superior).toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><b>Peers</b></td>
                                                                            <td>{parseFloat(item?.scho_peers).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_peers).toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><b>Direct-Report</b></td>
                                                                            <td>{parseFloat(item?.scho_direct_report).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_direct_report).toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><b>Other</b></td>
                                                                            <td>{parseFloat(item?.scho_other).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_other).toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><b>Self</b></td>
                                                                            <td>{parseFloat(item?.scho_self).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_self).toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><b>Overall</b></td>
                                                                            <td>{parseFloat(item?.scho_overall).toFixed(2)}</td>
                                                                            <td>{parseFloat(item?.r_overall).toFixed(2)}</td>
                                                                        </tr>
                                                                    </tbody>

                                                                </Table>

                                                            </div>
                                                        </Col>
                                                    )
                                                }

                                                )
                                            }
                                        </Row>

                                }
                            </div>
                            {/* {
                                tableData?.records < filterData?.limit ?
                                    ""
                                    :
                                    <MyPagination
                                        filterData={filterData}
                                        recordsPerPage={filterData?.limit}
                                        totalRecords={tableData?.records}
                                        currentPage={currentPage}
                                        onPageChange={(pageNumber) => {
                                            setCurrentPage(pageNumber)
                                            setFilterData(prevFilterData => ({
                                                ...prevFilterData,
                                                page: pageNumber
                                            }));
                                        }}
                                    />
                            } */}
                        </Col>
                    </Row>
                </div>
            </div >
        </React.Fragment >
    );
}

List.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(List);
